import { get } from 'lodash-es';

export const isElectricVehicle = vehicle =>
  get(vehicle, 'vehicleInfo.partsInfo.engineType', '').toLowerCase() === 'electric';

export const isPlugInHybridVehicle = vehicle =>
  get(vehicle, 'vehicleInfo.partsInfo.engineType', '').toLowerCase() === 'plug-in hybrid';
